import { Injectable, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { SportsService } from '../../../services/sport.service';
import { TranslationService } from '../../../services/translation.service';

@Injectable({
  providedIn: 'root',
})
export class OddsService {
  private urlAPI = environment.API;

  @Output() changeFavorites = new EventEmitter<any>();
  @Output() changeTeamFavorites = new EventEmitter<any>();

  constructor(
    private readonly sportsServices: SportsService,
    private readonly translatorService: TranslationService,
    private http: HttpClient
  ) {}

  getOdds(): Observable<any> {
    return this.http.get<any>(
      `${
        this.urlAPI
      }getOdds/${this.sportsServices.getSelectedSport()}/${this.translatorService.getCurrentLanguage()}`
    );
  }

  getMatchOdds(idHome: string, idAway: string): Observable<any> {
    return this.http.get<any>(
      `${
        this.urlAPI
      }getMatchOdd/${this.sportsServices.getSelectedSport()}/${idHome}/${idAway}/${this.translatorService.getCurrentLanguage()}`
    );
  }
}
